import { render, staticRenderFns } from "./editAuthId.vue?vue&type=template&id=15fd1f30&scoped=true"
import script from "./editAuthId.vue?vue&type=script&lang=js"
export * from "./editAuthId.vue?vue&type=script&lang=js"
import style0 from "./editAuthId.vue?vue&type=style&index=0&id=15fd1f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd1f30",
  null
  
)

export default component.exports